import { channelClient } from 'shared/channels';
import { dbChangesContract } from './dbChangesContract';

/** Notices of stored data changes, as the page asks for them. */
export const dbChangesClient = {
  startListening(): void {
    channelClient.notify(dbChangesContract, 'startListening', undefined);
  },
};
